/*
 * Cálculo de desconto com base no formulário de item do pedido
 * formato de attributes deve ser:
 * { value, quantity, discount_percentage, discount_value }
 */
import Decimal from 'decimal.js'
import { decimalFormat } from './format'

export const DISCOUNT_VALUE = 'value'
export const DISCOUNT_PERCENTAGE = 'percentage'

const calcDiscount = (toCalculate, attributes, discount) => {
  if (!attributes.quantity) return null

  const currentDiscount = Decimal(discount)
  const qtt = Decimal(attributes.quantity)
  const price = Decimal(decimalFormat(attributes.value))

  const total = qtt.times(price)
  if (toCalculate === DISCOUNT_PERCENTAGE) {
    return total.dividedBy(100).times(currentDiscount).toFixed(2)
  }

  return currentDiscount.dividedBy(total).times(100).toFixed(4)
}

const calculateDiscountByValue = (attributes) => (
  calcDiscount(DISCOUNT_VALUE, attributes, attributes.discount_value)
)

const calculateDiscountByPercentage = (attributes) => (
  calcDiscount(DISCOUNT_PERCENTAGE, attributes, attributes.discount_percentage)
)

export const calculateDiscount = (type, attributes) => {
  if (type === DISCOUNT_PERCENTAGE) {
    return calculateDiscountByPercentage(attributes)
  }

  return calculateDiscountByValue(attributes)
}
